<template>
  <li
    class="calendar-month-section"
    :class="getStylesForMobileView()"
    @mouseover="hovered = true"
    @mouseleave="hovered = false"
  >
    <p
      v-if="rowType === 'weekHeader'"
      class="calendar-week-header calendar-days-of-week"
    >
      {{ day.name }}
    </p>
    <div v-else class="calendar-day-of-month">
      <p
        class="calendar-week-header"
        :class="{
          calendar_active_month: activeMonth === new Date(+day.date).getMonth(),
          calendar_active_day:
            new Date().toDateString() === new Date(+day.date).toDateString(),
        }"
      >
        {{ data }}
      </p>
      <div v-if="categories.length" class="calendar-month__categories">
        <div
          v-for="(category, index) of categories"
          :key="index"
          :class="[
            'calendar-month__category',
            'calendar-month__category_' + category,
          ]"
        ></div>
      </div>
      <ol class="list-unstyled calendar-day-of-month__tickers-list">
        <li v-for="(event, index) of eventsOfCompanies" :key="index">
          <h6
            v-if="
              (index < 3 && eventsOfCompanies.length > 4) ||
                eventsOfCompanies.length <= 4
            "
            class="calendar-day-of-month__ticker"
          >
            {{ event.companyName | shortText(tickerLength[$mq], '…') }}
          </h6>
        </li>
        <li
          v-if="eventsOfCompanies.length > 4"
          class="calendar-week-header calendar-day-of-month__hide-tickers"
        >
          <p>
            {{ $t('calendar.events.more', [eventsOfCompanies.length - 3]) }}
          </p>
        </li>
      </ol>
    </div>
    <day-opened ref="openedDayElem" v-if="showDay" />
  </li>
</template>

<script>
import filters from '@/utils/filters'
import MonthDayOpened from './MonthDayOpened.vue'

const HOVER_TIMEOUT = 300
const LEAVE_TIMEOUT = 300

export default {
  props: {
    day: {
      type: Object,
      required: true,
    },
    activeMonth: {
      type: Number,
    },
    rowType: {
      type: String,
    },
  },
  data() {
    return {
      data: new Date(+this.day.date).getDate(),
      //company name query-dependent length for shortText filter
      tickerLength: { md: 7, lg: 9, xl: 12, xxl: 18, xxxl: 22 },
      showDay: false,
      hovered: false,
    }
  },
  watch: {
    hovered(newVal) {
      if (newVal)
        this.hoverTimer = setTimeout(() => {
          this.loadFullData()
        }, HOVER_TIMEOUT)
      else clearTimeout(this.hoverTimer)

      if (!newVal)
        this.leaveTimer = setTimeout(() => {
          this.showDay = false
        }, LEAVE_TIMEOUT)
      else clearTimeout(this.leaveTimer)
    },
  },
  computed: {
    //computed array that contains objects like {ticker: 'name_of_ticker', events: ['title_of_event_1', 'title_of_event_2', ...]}
    eventsOfCompanies() {
      let array = []
      //get companyNames and titles of events from array day.events
      for (let event of this.day.events) {
        //find in array object with the same companyName of the event
        //will return that object or 0, if the companyName not found
        let res =
          array.find(
            (eventOfArray) =>
              eventOfArray.companyName ===
              event[`CompanyName_${this.$i18n.locale}`]
          ) || 0
        if (res) {
          //check the same event on another market
          if (!res.events.find((eventOfArray) => eventOfArray.id === event.id))
            res.events.push({ id: event.id })
        } else {
          //else make new object with companyName and event
          let obj = {
            companyName: event[`CompanyName_${this.$i18n.locale}`],
            events: [{ id: event.id }],
          }
          //and push it in array
          array.push(obj)
        }
      }
      return array
    },
    categories() {
      let arrayOfCategories = []
      this.day.events.forEach((event) => {
        //check the same category of event
        if (!arrayOfCategories.find((category) => category === event.cat))
          arrayOfCategories.push(event.cat)
      })
      return arrayOfCategories
    },
  },
  methods: {
    loadFullData() {
      if (this.day && this.day.events && this.day.events.length > 0) {
        this.showDay = true
        this.$nextTick(() => {
          this.$refs.openedDayElem.loadDay(new Date(this.day.date))
        })
      }
    },
    getStylesForMobileView() {
      let arrayOfClasses = new Array()
      if (this.activeMonth !== new Date(+this.day.date).getMonth())
        arrayOfClasses.push('calendar_not_active')
      if (
        this.activeMonth === new Date(+this.day.date).getMonth() &&
        1 === new Date(+this.day.date).getDate()
      )
        arrayOfClasses.push(
          'calendar_first_day_' +
            (new Date(+this.day.date).getDay() === 0
              ? 7
              : new Date(+this.day.date).getDay())
        )
      if (arrayOfClasses.length) return arrayOfClasses
    },
  },
  filters: {
    shortText: filters.shortText,
  },
  components: {
    'day-opened': MonthDayOpened,
  },
}
</script>

<style lang="scss">
.calendar {
  &-month {
    &-section {
      position: relative;
      width: calc((100% - 6 * 1.73333rem) / 7);
      display: inline-block;
      vertical-align: top;
      margin: 0 0.86666rem;
      z-index: 0;
      border-bottom: #c2c2d6 0.06666rem solid;
      &:nth-of-type(7n + 1) {
        margin-left: 0;
      }
      &:nth-of-type(7n) {
        margin-right: 0;
      }
    }
    &__categories {
      display: inline-block;
      margin: 0px 6px;
    }
    &__category {
      width: 5px;
      height: 5px;
      border-radius: 50%;
      display: inline-block;
      margin-bottom: 1px;
      margin-right: 4px;
      &_div {
        background: #007aff;
      }
      &_event {
        background: #af52de;
      }
    }
  }
  &-week-header {
    font-size: 0.75rem;
    margin-bottom: 0.5rem;
    display: inline;
  }
  &-day-of-month {
    height: 9.13333rem;
    padding-top: 14px;
    line-height: 0;
    cursor: pointer;
    z-index: 20;
    &__tickers-list {
      margin-top: 0.86666rem;
    }
    &__ticker {
      line-height: 1.15rem;
    }
    &__hide-tickers {
      margin-top: 1rem;
    }
    &:hover:before {
      content: '';
      position: absolute;
      top: -0.13333rem;
      left: -0.86666rem;
      width: calc(100% + 1.66667rem);
      height: calc(100% + 0.26666rem);
      background: #fcfcfd;
      border: #c2c2d6 0.06666rem solid;
      box-sizing: border-box;
      border-radius: 8px;
      z-index: -10;
    }
  }

  @media (max-width: 576px) {
    &-month {
      &-section {
        width: calc((100% - 2.66666rem * 2) / 5);
        border: none;
        margin: 0;
        margin-bottom: 3px;
        border-bottom: #e0e0ea 0.06666rem solid;
        &:nth-of-type(-n + 7) {
          display: none;
        }
        &:nth-of-type(7n),
        &:nth-of-type(7n - 6) {
          width: 2.66666rem;
        }
      }
      &__categories {
        display: block;
        text-align: center;
        padding-top: 4px;
      }
      &__category {
        margin: 0px 1px;
      }
    }
    &-week-header {
      display: block;
      font-size: 16px;
      text-align: center;
    }
    &-day-of-month {
      height: 40px;
      padding-top: 19px;
      &__tickers-list {
        display: none;
      }
      &:hover:before {
        display: none;
      }
    }
    &_not_active {
      opacity: 0;
    }
  }
}

#app[data-theme='dark'] {
  .calendar {
    &-week-header {
      color: $text-color;
    }
    &-days-of-week {
      color: #fff;
    }
    &-day-of-month {
      &:hover:before {
        background: #252525;
      }
    }
  }
}
</style>
